import mcLib from './mc-lib';

export function sendEvent(action, value, detail: '') {
  const eventAction = `${value}:${action}`;
  const eventLabel = detail && detail.toString ? detail.toString() : '';
  mcLib.logEvent(eventAction, eventLabel);
}
